import * as React from 'react';
import { Classes } from '../index';
import classNames from 'classnames';

export type DetailMenuProps = {
  className?: string;
  label: string;
};

export const DetailMenuLabel: React.FC<DetailMenuProps> = ({
  className,
  label,
}) => {
  return (
    <div className={classNames(Classes.DETAIL_MENU_LABEL, className)}>
      {label}
    </div>
  );
};
